import React, { useEffect } from "react";
import OrgTickets from "../components/orgTickets";
import { compose } from "modules/core";
import { GET_TICKETS_BY_ORG_ID } from "../graphql/org-ticket-queries.gql";
import { withApollo } from '@apollo/client/react/hoc';
import { getIntFromString, globalPermissionValidator } from "modules/look";
import { poc_admin_permission } from "Permissions/poc_admin.permission";
import NoPermissionView from "modules/kudos-user/component/NoPermissionComponent";
import { ticket_and_support_permissions } from "Permissions/ticketSupport.permissions";
import am_dashboard_routes from "../routes";
import { getOrgID } from "modules/poc-dashboard/containers/organization/organizationOperations";
import { Spin } from "antd";

const OrgTicketContainer = (props) => {
    const { client, me, userPermission, orgToFetchData } = props;

    const [allTickets, setAllTickets] = React.useState([]);
    const [ticket_loading, setTicketLoading] = React.useState(false);
    const [pagination_info, setPaginationInfo] = React.useState();
    const [permissionLoader, setPermissionLoader] = React.useState(true);
    const [ticketSupportPermission, setTicketSupportPermission] = React.useState(null);
    const [pocAdminPermission, setPocAdminPermission] = React.useState(null);

    const filter_ref = React.useRef({});
    const all_ticket_ref = React.useRef([]);
    useEffect(() => {
        if (orgToFetchData?.id === getOrgID(props)) {
            getOrgTickets({ status_In: ["Assigned", "New", "Work in Progress"], offset: 0 });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orgToFetchData]);

    
    React.useEffect(() => {
        all_ticket_ref.current = allTickets;
    }, [allTickets]);

  React.useEffect(() => {
    if (userPermission?.length && me) {
        let ticketSupport = globalPermissionValidator(ticket_and_support_permissions, userPermission);
        let pocAdmin = globalPermissionValidator(poc_admin_permission, userPermission);

        if (pocAdmin?.required_permission && !me?.employee?.orgAmEmployee?.totalCount) {
            if (!me?.employee?.orgPocEmployee?.totalCount) {
                pocAdmin.required_permission = false;
            }
            if (!me?.employee?.organizationSet?.edges?.length) {
                pocAdmin.required_permission = false;
            }
        }

        // Exclude certain routes from ticketSupport permission
        if (
            ticketSupport?.required_permission &&
            Object.values(am_dashboard_routes).includes(window.location?.pathname)
        ) {
            ticketSupport.required_permission = false;
        }

        setTicketSupportPermission(ticketSupport);
        setPocAdminPermission(pocAdmin);
        setPermissionLoader(false); // ✅ only set when permission data is fully evaluated
    } else {
        console.warn("userPermission or me not ready yet:", { userPermission, me });
    }
}, [userPermission, me, orgToFetchData]);

    const getOrgTickets = async (filter = {}) => {
        try {
            filter_ref.current = { ...filter };
            setTicketLoading(true);

            const { data } = await client.query({
                query: GET_TICKETS_BY_ORG_ID,
                variables: {
                    orgId: getIntFromString(getOrgID(props) || orgToFetchData?.id),
                    ...filter,
                    first: 10,
                },
                fetchPolicy: 'network-only',
            });

            if (data.orgTicketByOrgId) {
                setPaginationInfo({
                    totalCount: data.orgTicketByOrgId.totalCount,
                    pageInfo: data.orgTicketByOrgId.pageInfo,
                });
                setAllTickets(data?.orgTicketByOrgId?.edges?.map(({ node }) => node));
            }

        } catch (error) {
            console.error("orgTicketContainer -> getOrgTickets", error);
        } finally {
            setTicketLoading(false);
        }
    };

    if (permissionLoader) {
        return    <Spin spinning={permissionLoader} size="large"/>
    }

    const hasAccess =
        ticketSupportPermission?.required_permission || pocAdminPermission?.required_permission;

    return hasAccess ? (
        <OrgTickets
            allTickets={allTickets}
            getOrgTickets={(filter) => getOrgTickets({ ...filter })}
            ticket_loading={ticket_loading}
            pagination_info={pagination_info}
            {...props}
        />
    ) : (
        <NoPermissionView />
    );
};

export default compose(withApollo)(OrgTicketContainer);
